module.exports = __webpack_public_path__ + "static/media/footer-logo.960a43d8.svg";